export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Errore inizializzazione",
    "StaticConfigLoader.caption.init": "Inizializzazione",
    "StaticConfigLoader.text.init": "Inizializzazione applicazione…",
    "StaticConfigLoader.error.settings": "Impossibile caricare le impostazioni del sito",
    "StaticConfigLoader.error.circuits": "Impossibile caricare la configurazione dei servizi",
    //app
    "Legal.Localization": "it",
    "AchievementApp.Navbar.storeTitle": "Negozio",
    "AchievementApp.Navbar.supportTitle": "Supporto",
    "Legal.TermsConditions": "Termini e condizioni",
    "Legal.TermsService": "Termini servizio",
    "Legal.PrivacyPolicy": "Politica privacy",
    "Legal.CookiesPolicy": "Impostazioni dei cookie",
    "Legal.Copyright": "Tutti i marchi,loghi e nomi delle marche appartengono ai loro rispettivi proprietari.",
    "AchievementApp.Navbar.achievement": "Obiettivi personali",
    "AchievementApp.Navbar.userAchievement": "Obiettivi dell’utente",
    "AchievementApp.Navbar.settingsLink": "Impostazioni",
    "AchievementApp.Navbar.profileLink": "Profilo",
    "AchievementApp.Navbar.reloginLink": "Accedi di nuovo o cambia account",
    "AchievementApp.Navbar.pageTitlePrew": "Obiettivi di ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Completato",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Filtra per titoli",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "I miei amici",
    "UserFriendsList.heading.showMore": "Mostra altro",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Devi configurare l’autorizzazione a due fattori",
    "LimitedAccountPanel.2step.link": "Informazioni sull’autenticazione a due fattori",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Devi confermare il tuo indirizzo e-mail",
    "LimitedAccountPanel.email.link": "Vai al profilo",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Il tuo account è limitato a causa di:",
    "LimitedAccountPanel.conclusion": "Dopo aver modificato le impostazioni di sicurezza, devi effettuare il logout e accedere di nuovo per applicare le modifiche",
    "LimitedAccountPanel.relogin": "Accedi di nuovo",
    "EmailVerificationStateIcon.success": "Account confermato, e-mail verificata",
    "EmailVerificationStateIcon.warning": "Account non confermato, e-mail non verificata",
    "EmailVerificationStateIcon.danger": "Account non confermato, verifica dell’e-mail RICHIESTA",
    "TwoFactorStateIcon.success": "Account protetto con autenticazione a due fattori",
    "TwoFactorStateIcon.warning": "Account non sicuro, autorizzazione a due fattori disabilitata",
    "TwoFactorStateIcon.danger": "Autenticazione a due fattori RICHIESTA",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Salva impostazioni",
    "UserSettingDialog.settings": "Impostazioni",
    "UserSettingDialog.userSettings": "Impostazioni utente",
    "UserSettingDialog.language": "Lingua",
    "UserSettingDialog.privacy": "Privacy",
    "UserSettingDialog.allUsers": "Tutti gli utenti",
    "UserSettingDialog.friendsOnly": "Solo amici",
    "UserSettingDialog.onlyMe": "Solo io",
    "UserSettingDialog.whoCanView": "Chi può vedere i miei obiettivi",
    //unlockProgress
    "ViewUnlockProgress.of": " su ",
    "ViewUnlockProgress.achievCompleted": " obiettivi completati",
    "ViewUnlockProgress.myUnlock": "I miei obiettivi",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Cerca il nickname qui",
    "ViewItemSearch.label.search": "Cerca utenti",
    "ViewItemSearch.resultNotFound": "Utente non trovato",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Obiettivo",
    "ViewItemSearch.stub.empty": "Nessun obiettivo",
    "ViewItemSearch.stub.emptyCompare_1": "L’utente ",
    "ViewItemSearch.stub.emptyCompare_2": " non ha obiettivi in questo gioco",
    "ViewItemSearch.limitedAccess": "L’accesso agli obiettivi dell’utente selezionato è limitato",
    "ViewItemSearch.heading.selectGame": "Scegli un gioco dall’elenco",
    "ViewItemSearch.globalstat.opened": "sbloccato dal ",
    "ViewItemSearch.globalstat.ofGamers": "% dei giocatori",
    //authentication
    "NotAllowedMessage.caption": "Non consentito",
    "NotAllowedMessage.body.h1": "Accesso agli obiettivi",
    "NotAllowedMessage.body.h3": "attualmente non consentito per il tuo account",
    "NotAllowedMessage.relogin": "Cambia account",
    "LandingMessage.caption": "Autenticazione",
    "LandingMessage.body": "Controlli finali…",
    "TokenExpiredMessage.caption": "Autenticazione scaduta",
    "TokenExpiredMessage.body.h3": "Per continuare devi effettuare di nuovo l’accesso",
    "TokenExpiredMessage.relogin": "Accedi di nuovo",
    "AuthErrorMessage.caption": "Autenticazione non riuscita",
    "AuthErrorMessage.body.h1": "Controllo autenticazione non riuscito",
    "AuthErrorMessage.body.code": "Codice",
    "AuthErrorMessage.body.desc": "Per continuare devi effettuare di nuovo l’accesso",
    "AuthErrorMessage.relogin": "Accedi di nuovo",
    "AuthorizationRequiredMessage.caption": "Autenticazione richiesta",
    "AuthorizationRequiredMessage.body.h3.1": "Stai per accedere a",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "Ma ti serve l’autorizzazione per poter procedere",
    "AuthorizationRequiredMessage.login": "Accedi con gaijin.net",
    "CheckingAuthMessage.caption": "Autenticazione",
    "CheckingAuthMessage.body": "Controllo autenticazione, ti preghiamo di attendere",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Questa versione mobile è temporaneamente non disponibile",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Utilizza la versione per computer",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Ci scusiamo",
}